import {
  // request state
  REQUEST_INIT,
  REQUEST_NORMAL,
  REQUEST_LOADING,
  REQUEST_SUCCESS,
  REQUEST_FAIL,
  RESET_ITINERARY,
  // actions types
  FETCH_POI_ROUTE,
  FETCH_POI_ROUTE_SUCCESS,
  FETCH_POI_ROUTE_FAIL,
  FETCH_INIT, // init
  FETCH_INIT_SUCCESS,
  FETCH_INIT_FAIL,
  FETCH_POI_BANK_INIT, // poi bank init
  FETCH_POI_BANK_INIT_SUCCESS,
  FETCH_POI_BANK_INIT_FAIL,
  FETCH_POIS, // pois
  FETCH_POIS_SUCCESS,
  FETCH_POIS_FAIL,
  FETCH_POI_DETAIL, // poi detail
  FETCH_POI_DETAIL_SUCCESS,
  FETCH_POI_DETAIL_FAIL,
  FETCH_TEXT_NOTE, // text note
  FETCH_TEXT_NOTE_SUCCESS,
  FETCH_TEXT_NOTE_FAIL,
  USER_LOGIN, // login
  USER_LOGIN_SUCCESS,
  USER_LOGIN_FAIL,
  USER_LOG_OUT,
  FETCH_MY_TRIP_LIST, // my rip list
  FETCH_MY_TRIP_LIST_SUCCESS,
  FETCH_MY_TRIP_LIST_FAIL,
  RESET_MY_TRIP_LIST,
  ERASE_TRIP_LIST,
  FETCH_TRAVEL_GROUP_LIST, // travel group list
  FETCH_TRAVEL_GROUP_LIST_SUCCESS,
  FETCH_TRAVEL_GROUP_LIST_FAIL,
  UPDATE_PUBLIC_STATUS, // update public status
  UPDATE_PUBLIC_STATUS_SUCCESS,
  UPDATE_PUBLIC_STATUS_FAIL,
  UPDATE_TRIP_INFO, // update trip info
  UPDATE_TRIP_INFO_SUCCESS,
  UPDATE_TRIP_INFO_FAIL,
  EDIT_ALIAS_NAME, // edit alias name
  EDIT_ALIAS_NAME_SUCCESS,
  EDIT_ALIAS_NAME_FAIL,
  ONE_MORE_DAY,
  ONE_MORE_DAY_FAIL,
  ONE_MORE_DAY_SUCCESS,
  UPDATE_START_TIME,
  UPDATE_START_TIME_FAIL,
  UPDATE_START_TIME_SUCCESS,
  UPDATE_STAY_TIME,
  UPDATE_STAY_TIME_FAIL,
  UPDATE_STAY_TIME_SUCCESS,
  REINDEX_DAY_SEQUENCE,
  REINDEX_DAY_SEQUENCE_FAIL,
  REINDEX_DAY_SEQUENCE_SUCCESS,
  REINDEX_POI_SEQUENCE,
  REINDEX_POI_SEQUENCE_FAIL,
  REINDEX_POI_SEQUENCE_SUCCESS,
  COPY_POI,
  COPY_POI_FAIL,
  COPY_POI_SUCCESS,
  REMOVE_POIS,
  REMOVE_POIS_FAIL,
  REMOVE_POIS_SUCCESS,
  REMOVE_DAYS,
  REMOVE_DAYS_FAIL,
  REMOVE_DAYS_SUCCESS,
  ADD_TRIP,
  ADD_TRIP_FAIL,
  ADD_TRIP_LOADING,
  ADD_TRIP_SUCCESS,
  COPY_TRIP,
  COPY_TRIP_FAIL,
  COPY_TRIP_SUCCESS,
  DELETE_TRIP,
  DELETE_TRIP_FAIL,
  DELETE_TRIP_SUCCESS,
  DELETE_SHARED_TRIP,
  DELETE_SHARED_TRIP_FAIL,
  DELETE_SHARED_TRIP_SUCCESS,
  ACCEPT_SHARED_TRIP,
  ACCEPT_SHARED_TRIP_FAIL,
  ACCEPT_SHARED_TRIP_SUCCESS,
  ACCEPT_SEND_ITINERARY,
  ACCEPT_SEND_ITINERARY_FAIL,
  ACCEPT_SEND_ITINERARY_SUCCESS,
  CUSTOMIZE_TRANSPORTATION_TIME,
  CUSTOMIZE_TRANSPORTATION_TIME_FAIL,
  CUSTOMIZE_TRANSPORTATION_TIME_SUCCESS,
  FETCH_MY_COLLECTIONS,
  FETCH_MY_COLLECTIONS_FAIL,
  FETCH_MY_COLLECTIONS_SUCCESS,
  FETCH_SHARED_COLLECTIONS_FOLDERS,
  FETCH_SHARED_COLLECTIONS_FOLDERS_FAIL,
  FETCH_SHARED_COLLECTIONS_FOLDERS_SUCCESS,
  FETCH_MY_COLLECTIONS_IN_FOLDER,
  FETCH_MY_COLLECTIONS_IN_FOLDER_FAIL,
  FETCH_MY_COLLECTIONS_IN_FOLDER_SUCCESS,
  ADD_POI_TO_COLLECTIONS,
  ADD_POI_TO_COLLECTIONS_FAIL,
  ADD_POI_TO_COLLECTIONS_SUCCESS,
  ADD_POI,
  ADD_POI_FAIL,
  ADD_POI_SUCCESS,
  GEO_CODE,
  GEO_CODE_FAIL,
  GEO_CODE_SUCCESS,
  // poi bank
  FETCH_POI_DETAIL_FROM_POI_BANK, // poi detail from poi bank
  FETCH_POI_DETAIL_FROM_POI_BANK_SUCCESS,
  FETCH_POI_DETAIL_FROM_POI_BANK_FAIL,
  FETCH_CITY_AUTOCOMPLETE,
  FETCH_CITY_AUTOCOMPLETE_SUCCESS,
  FETCH_CITY_AUTOCOMPLETE_FAIL,
  CLEAR_CITY_AUTOCOMPLETE,
  FETCH_RECOMMENDED_POI_FAIL,
  SEARCH_POI_FAIL,
  SEARCH_POI,
  POI_BANK_CITY_GEOCODE_SUCCESS,
  POI_BANK_CITY_GEOCODE_FAIL,
  POI_BANK_CITY_GEOCODE,
  CLEAR_POI_LIST,
  // journal like
  FETCH_JOURNAL_LIKE_SUCCESS,
  FETCH_JOURNAL_LIKE_FAIL,
  FETCH_JOURNAL_LIKE_LOADING,
  GET_MYTRIP_LIST_SUCCESS,
  GET_MYTRIP_LIST_FAIL,
  GET_MYTRIP_LIST_LOADING,
  GET_NEXT_MYTRIP_LIST_SUCCESS,
  GET_NEXT_MYTRIP_LIST_FAIL,
  GET_NEXT_MYTRIP_LIST_LOADING,
  GET_GROUPTRIP_LIST_SUCCESS,
  GET_GROUPTRIP_LIST_FAIL,
  GET_GROUPTRIP_LIST_LOADING,
  GET_NEXT_GROUPTRIP_LIST_SUCCESS,
  GET_NEXT_GROUPTRIP_LIST_FAIL,
  GET_NEXT_GROUPTRIP_LIST_LOADING,
  POST_TRIP_PUBLIC_STATUS_SUCCESS,
  POST_TRIP_PUBLIC_STATUS_LOADING,
  POST_TRIP_PUBLIC_STATUS_FAIL,
  COPY_TRIP_FROM_ITINERARY,
  RESET_POST_TRIP_PUBLIC_STATUS
} from '../actions/action_types';

import { FETCH_COLLECTIONS_FOLDERS } from '../actionTypes/collection';

// 太多狀態了 若元件 unMount 時要初始化就需要記得一開始狀態
const originState = {
  initRequestStatus: { state: REQUEST_NORMAL },
  fetchPoisRequestStatus: {
    state: REQUEST_NORMAL,
    requestId: null,
    statusCode: null
  },
  fetchPoiDetailRequestStatus: { state: REQUEST_NORMAL, requestId: null },
  fetchTextNoteRequestStatus: { state: REQUEST_NORMAL, requestId: null },
  fetchRouteRequestStatus: { state: REQUEST_NORMAL, requestId: null },
  fetchMyTripListRequestStatus: { state: REQUEST_NORMAL },
  getMyTripList: { state: REQUEST_INIT },
  getGroupTripList: { state: REQUEST_INIT },
  getNextMyTripList: { state: REQUEST_INIT },
  postTripPublicStatus: { state: REQUEST_INIT },
  userLoginRequestStatus: { state: REQUEST_NORMAL },
  updatePublicStatusOfTripRequestStatus: {
    state: REQUEST_NORMAL,
    requestId: null
  },
  updateTripInfoRequestStatus: {
    state: REQUEST_NORMAL,
    requestId: null,
    isUpdateDate: false
  },
  editAliasNameRequestStatus: { state: REQUEST_NORMAL, requestId: null },
  oneMoreDayRequestStatus: { state: REQUEST_NORMAL, requestId: null },
  updateStartTimeRequestStatus: { state: REQUEST_NORMAL, requestId: null },
  updateStayTimeRequestStatus: { state: REQUEST_NORMAL, requestId: null },
  reindexDaySequenceRequestStatus: { state: REQUEST_NORMAL, requestId: null },
  reindexPoiSequenceReqeustStatus: { state: REQUEST_NORMAL, requestId: null },
  copyPoiRequestStatus: { state: REQUEST_NORMAL, requestId: null },
  removePoisRequestStatus: { state: REQUEST_NORMAL, requestId: null },
  removeDaysRequestStatus: { state: REQUEST_NORMAL, requestId: null },
  addTripRequestStatus: { state: REQUEST_NORMAL, requestId: null },
  copyTripRequestStatus: { state: REQUEST_NORMAL, requestId: null },
  deleteTripRequestStatus: { state: REQUEST_NORMAL, requestId: null },
  deleteSharedTripRequestStatus: { state: REQUEST_NORMAL, requestId: null },
  acceptSendItineraryRequestStatus: {
    state: REQUEST_NORMAL,
    requestId: null
  },
  acceptSharedTripRequestStatus: { state: REQUEST_NORMAL, requestId: null },
  customizeTransportationTimeRequestStatus: {
    state: REQUEST_NORMAL,
    requestId: null
  },
  fetchMyCollectionsRequestStatus: { state: REQUEST_NORMAL, requestId: null },
  fetchMyCollectionsFoldersRequestStatus: {
    state: REQUEST_NORMAL,
    requestId: null
  },
  fetchSharedCollectionsFoldersRequestStatus: {
    state: REQUEST_NORMAL,
    requestId: null
  },
  fetchMyCollectionsInFolderRequestStatus: {
    state: REQUEST_NORMAL,
    requestId: null
  },
  addPoiToCollectionsRequestStatus: {
    state: REQUEST_NORMAL,
    requestId: null
  },
  addPoiToTripRequestStatus: { state: REQUEST_NORMAL, requestId: null },
  geocodeRequestStatus: { state: REQUEST_NORMAL, requestId: null },
  fetchMyCollectionListRequstStatus: {
    state: REQUEST_NORMAL,
    requestId: null
  },
  fetchMyCollectionsFolderListRequestStatus: {
    state: REQUEST_NORMAL,
    requestId: null
  },
  fetchSharedCollectionsFolderListRequestStatus: {
    state: REQUEST_NORMAL,
    requestId: null
  },
  // poi bank
  poiBankInitRequestStatus: { state: REQUEST_NORMAL },
  fetchPoiDetailFromPoiBankRequestStatus: {
    state: REQUEST_NORMAL,
    requestId: null
  },
  cityAutoCompleteRequestStatus: { state: REQUEST_NORMAL, requestId: null },
  fetchRecommendedPoiRequestStatus: {
    state: REQUEST_NORMAL,
    requestId: null
  },
  searchPoiRequestStatus: { state: REQUEST_NORMAL, requestId: null },
  cityGeocodeRequestStatus: { state: REQUEST_NORMAL, requestId: null },

  // journals like
  fetchJournalLikeRequestStatus: { state: REQUEST_NORMAL, requestId: null },
  // social copy
  fetchSocialCopyRequestStatus: { state: REQUEST_INIT }
};

export default (state = { ...originState }, action) => {
  const { type, payload } = action;
  // console.log('view state reducer = ', type);
  switch (type) {
    case FETCH_POI_ROUTE: // loading route data
      return {
        ...state,
        fetchRouteRequestStatus: {
          state: REQUEST_LOADING,
          requestId: payload.poiObjectId
        }
      };
    case FETCH_POI_ROUTE_SUCCESS: // route request success
      return {
        ...state,
        fetchRouteRequestStatus: {
          state: REQUEST_SUCCESS,
          requestId: payload.poiObjectId
        }
      };
    case FETCH_POI_ROUTE_FAIL: // route request fail
      return {
        ...state,
        fetchRouteRequestStatus: {
          state: REQUEST_FAIL,
          requestId: payload.poiObjectId
        }
      };
    case FETCH_INIT: // loading init data
      return { ...state, initRequestStatus: { state: REQUEST_LOADING } };
    case FETCH_INIT_SUCCESS: // init request success
      return { ...state, initRequestStatus: { state: REQUEST_SUCCESS } };
    case FETCH_INIT_FAIL: // init request fail
      return { ...state, initRequestStatus: { state: REQUEST_FAIL } };
    case FETCH_POI_BANK_INIT: // loading init data from poi bank
      return { ...state, poiBankInitRequestStatus: { state: REQUEST_LOADING } };
    case FETCH_POI_BANK_INIT_SUCCESS: // poi bank init request success
      return { ...state, poiBankInitRequestStatus: { state: REQUEST_SUCCESS } };
    case FETCH_POI_BANK_INIT_FAIL: // poi bank init request fail
      return { ...state, poiBankInitRequestStatus: { state: REQUEST_FAIL } };
    case FETCH_POIS: // loading pois data
      return {
        ...state,
        fetchPoisRequestStatus: {
          state: REQUEST_LOADING,
          requestId: payload.tripObjectId
        }
      };
    case FETCH_POIS_SUCCESS: // pois request success
      return {
        ...state,
        fetchPoisRequestStatus: {
          state: REQUEST_SUCCESS,
          requestId: payload.tripObjectId,
          statusCode: '200'
        }
      };
    case FETCH_POIS_FAIL: // pois request fail
      return {
        ...state,
        fetchPoisRequestStatus: {
          state: REQUEST_FAIL,
          requestId: payload.tripObjectId,
          statusCode: payload.status
        }
      };
    case FETCH_POI_DETAIL: // loading poi detail data
      return {
        ...state,
        fetchPoiDetailRequestStatus: {
          state: REQUEST_LOADING,
          requestId: payload.poiObjectId
        }
      };
    case FETCH_POI_DETAIL_SUCCESS: // poi detail request success
      return {
        ...state,
        fetchPoiDetailRequestStatus: {
          state: REQUEST_SUCCESS,
          requestId: payload.poiObjectId
        }
      };
    case FETCH_POI_DETAIL_FAIL: // poi detail request fail
      return {
        ...state,
        fetchPoiDetailRequestStatus: {
          state: REQUEST_FAIL,
          requestId: payload.poiObjectId
        }
      };
    case FETCH_TEXT_NOTE: // loading poi detail data
      return {
        ...state,
        fetchTextNoteRequestStatus: {
          state: REQUEST_LOADING,
          requestId: payload.poiObjectId
        }
      };
    case FETCH_TEXT_NOTE_SUCCESS: // poi detail request success
      return {
        ...state,
        fetchTextNoteRequestStatus: {
          state: REQUEST_SUCCESS,
          requestId: payload.poiObjectId
        }
      };
    case FETCH_TEXT_NOTE_FAIL: // poi detail request fail
      return {
        ...state,
        fetchTextNoteRequestStatus: {
          state: REQUEST_FAIL,
          requestId: payload.poiObjectId
        }
      };
    case GET_MYTRIP_LIST_LOADING:
      return {
        ...state,
        getMyTripList: { state: REQUEST_LOADING }
      };
    case GET_MYTRIP_LIST_SUCCESS:
      return {
        ...state,
        getMyTripList: { state: REQUEST_SUCCESS }
      };
    case GET_MYTRIP_LIST_FAIL:
      return {
        ...state,
        getMyTripList: { state: REQUEST_FAIL }
      };
    case GET_NEXT_MYTRIP_LIST_LOADING:
      return {
        ...state,
        getNextMyTripList: { state: REQUEST_LOADING }
      };
    case GET_NEXT_MYTRIP_LIST_SUCCESS:
      return {
        ...state,
        getNextMyTripList: { state: REQUEST_SUCCESS }
      };
    case GET_NEXT_MYTRIP_LIST_FAIL:
      return {
        ...state,
        getNextMyTripList: { state: REQUEST_FAIL }
      };
    case GET_GROUPTRIP_LIST_LOADING:
      return {
        ...state,
        getGroupTripList: { state: REQUEST_LOADING }
      };
    case GET_GROUPTRIP_LIST_SUCCESS:
      return {
        ...state,
        getGroupTripList: { state: REQUEST_SUCCESS }
      };
    case GET_GROUPTRIP_LIST_FAIL:
      return {
        ...state,
        getGroupTripList: { state: REQUEST_FAIL }
      };
    case GET_NEXT_GROUPTRIP_LIST_LOADING:
      return {
        ...state,
        getNextGroupTripList: { state: REQUEST_LOADING }
      };
    case GET_NEXT_GROUPTRIP_LIST_SUCCESS:
      return {
        ...state,
        getNextGroupTripList: { state: REQUEST_SUCCESS }
      };
    case GET_NEXT_GROUPTRIP_LIST_FAIL:
      return {
        ...state,
        getNextGroupTripList: { state: REQUEST_FAIL }
      };
    case POST_TRIP_PUBLIC_STATUS_SUCCESS:
      return {
        ...state,
        postTripPublicStatus: { state: REQUEST_SUCCESS }
      };
    case POST_TRIP_PUBLIC_STATUS_LOADING:
      return {
        ...state,
        postTripPublicStatus: { state: REQUEST_LOADING }
      };
    case POST_TRIP_PUBLIC_STATUS_FAIL:
      return {
        ...state,
        postTripPublicStatus: { state: REQUEST_FAIL }
      };
    case RESET_POST_TRIP_PUBLIC_STATUS:
      return {
        ...state,
        postTripPublicStatus: { state: REQUEST_INIT }
      };
    case FETCH_MY_TRIP_LIST:
      return {
        ...state,
        fetchMyTripListRequestStatus: { state: REQUEST_LOADING }
      };
    case FETCH_MY_TRIP_LIST_SUCCESS:
      return {
        ...state,
        fetchMyTripListRequestStatus: { state: REQUEST_SUCCESS }
      };
    case FETCH_MY_TRIP_LIST_FAIL:
      return {
        ...state,
        fetchMyTripListRequestStatus: { state: REQUEST_FAIL }
      };
    case RESET_MY_TRIP_LIST:
      return {
        ...state,
        fetchMyTripListRequestStatus: { state: REQUEST_NORMAL }
      };
    case FETCH_TRAVEL_GROUP_LIST:
      return {
        ...state,
        fetchMyTripListRequestStatus: { state: REQUEST_LOADING }
      };
    case FETCH_TRAVEL_GROUP_LIST_SUCCESS:
      return {
        ...state,
        fetchMyTripListRequestStatus: { state: REQUEST_SUCCESS }
      };
    case FETCH_TRAVEL_GROUP_LIST_FAIL:
      return {
        ...state,
        fetchMyTripListRequestStatus: { state: REQUEST_FAIL }
      };
    case UPDATE_PUBLIC_STATUS:
      return {
        ...state,
        updatePublicStatusOfTripRequestStatus: {
          state: REQUEST_LOADING,
          requestId: payload.tripObjectId,
          publicStatus: payload.publicStatus
        }
      };
    case UPDATE_PUBLIC_STATUS_SUCCESS:
      return {
        ...state,
        updatePublicStatusOfTripRequestStatus: {
          state: REQUEST_SUCCESS,
          requestId: payload.tripObjectId,
          publicStatus: payload.publicStatus
        }
      };
    case UPDATE_PUBLIC_STATUS_FAIL:
      return {
        ...state,
        updatePublicStatusOfTripRequestStatus: {
          state: REQUEST_FAIL,
          requestId: payload.tripObjectId,
          publicStatus: payload.publicStatus
        }
      };
    case UPDATE_TRIP_INFO:
      return {
        ...state,
        updateTripInfoRequestStatus: {
          state: REQUEST_LOADING,
          requestId: payload.tripObjectId,
          isUpdateDate: false
        }
      };
    case UPDATE_TRIP_INFO_SUCCESS:
      return {
        ...state,
        updateTripInfoRequestStatus: {
          state: REQUEST_SUCCESS,
          requestId: payload.tripObjectId,
          isUpdateDate: !payload.isTripName
        }
      };
    case UPDATE_TRIP_INFO_FAIL:
      // console.log(' update trip info fail');
      return {
        ...state,
        updateTripInfoRequestStatus: {
          state: REQUEST_FAIL,
          requestId: payload.tripObjectId
        }
      };
    case EDIT_ALIAS_NAME:
      return {
        ...state,
        editAliasNameRequestStatus: {
          state: REQUEST_LOADING,
          requestId: payload.poiObjectId
        }
      };
    case EDIT_ALIAS_NAME_SUCCESS:
      return {
        ...state,
        editAliasNameRequestStatus: {
          state: REQUEST_SUCCESS,
          requestId: payload.poiObjectId
        }
      };
    case EDIT_ALIAS_NAME_FAIL:
      return {
        ...state,
        editAliasNameRequestStatus: {
          state: REQUEST_FAIL,
          requestId: payload.poiObjectId
        }
      };
    case ONE_MORE_DAY:
      return {
        ...state,
        oneMoreDayRequestStatus: {
          state: REQUEST_LOADING,
          requestId: payload.tripObjectId
        }
      };
    case ONE_MORE_DAY_SUCCESS:
      return {
        ...state,
        oneMoreDayRequestStatus: {
          state: REQUEST_SUCCESS,
          requestId: payload.tripObjectId
        }
      };
    case ONE_MORE_DAY_FAIL:
      return {
        ...state,
        oneMoreDayRequestStatus: {
          state: REQUEST_FAIL,
          requestId: payload.tripObjectId
        }
      };
    case UPDATE_START_TIME:
      return {
        ...state,
        updateStartTimeRequestStatus: {
          state: REQUEST_LOADING,
          requestId: payload.tripObjectId,
          startTime: payload.startTime
        }
      };
    case UPDATE_START_TIME_SUCCESS:
      return {
        ...state,
        updateStartTimeRequestStatus: {
          state: REQUEST_SUCCESS,
          requestId: payload.tripObjectId,
          startTime: payload.startTime
        }
      };
    case UPDATE_START_TIME_FAIL:
      return {
        ...state,
        updateStartTimeRequestStatus: {
          state: REQUEST_FAIL,
          requestId: payload.tripObjectId
        }
      };
    case UPDATE_STAY_TIME:
      return {
        ...state,
        updateStayTimeRequestStatus: {
          state: REQUEST_LOADING,
          requestId: payload.poiObjectId,
          stayTime: payload.stayTime
        }
      };
    case UPDATE_STAY_TIME_SUCCESS:
      return {
        ...state,
        updateStayTimeRequestStatus: {
          state: REQUEST_SUCCESS,
          requestId: payload.poiObjectId,
          stayTime: payload.stayTime
        }
      };
    case UPDATE_STAY_TIME_FAIL:
      return {
        ...state,
        updateStayTimeRequestStatus: {
          state: REQUEST_FAIL,
          requestId: payload.poiObjectId,
          stayTime: payload.stayTime
        }
      };
    case REINDEX_DAY_SEQUENCE:
      return {
        ...state,
        reindexDaySequenceRequestStatus: {
          state: REQUEST_LOADING,
          requestId: payload.tripObjectId
        }
      };
    case REINDEX_DAY_SEQUENCE_SUCCESS:
      return {
        ...state,
        reindexDaySequenceRequestStatus: {
          state: REQUEST_SUCCESS,
          requestId: payload.tripObjectId
        }
      };
    case REINDEX_DAY_SEQUENCE_FAIL:
      return {
        ...state,
        reindexDaySequenceRequestStatus: {
          state: REQUEST_FAIL,
          requestId: payload.tripObjectId
        }
      };
    case REINDEX_POI_SEQUENCE:
      return {
        ...state,
        reindexPoiSequenceReqeustStatus: {
          state: REQUEST_LOADING,
          requestId: payload.poiObjectId
        }
      };
    case REINDEX_POI_SEQUENCE_SUCCESS:
      return {
        ...state,
        reindexPoiSequenceReqeustStatus: {
          state: REQUEST_SUCCESS,
          requestId: payload.poiObjectId
        }
      };
    case REINDEX_POI_SEQUENCE_FAIL:
      return {
        ...state,
        reindexPoiSequenceReqeustStatus: {
          state: REQUEST_FAIL,
          requestId: payload.poiObjectId
        }
      };
    case COPY_POI:
      return {
        ...state,
        copyPoiRequestStatus: {
          state: REQUEST_LOADING,
          requestId: payload.poiObjectId
        }
      };
    case COPY_POI_SUCCESS:
      return {
        ...state,
        copyPoiRequestStatus: {
          state: REQUEST_SUCCESS,
          requestId: payload.poiObjectId
        }
      };
    case COPY_POI_FAIL:
      return {
        ...state,
        copyPoiRequestStatus: {
          state: REQUEST_FAIL,
          requestId: payload.tripObjectId
        }
      };
    case REMOVE_POIS:
      return {
        ...state,
        removePoisRequestStatus: {
          state: REQUEST_LOADING,
          requestId: payload.tripObjectId
        }
      };
    case REMOVE_POIS_SUCCESS:
      return {
        ...state,
        removePoisRequestStatus: {
          state: REQUEST_SUCCESS,
          requestId: payload.tripObjectId
        }
      };
    case REMOVE_POIS_FAIL:
      return {
        ...state,
        removePoisRequestStatus: {
          state: REQUEST_FAIL,
          requestId: payload.tripObjectId
        }
      };
    case REMOVE_DAYS:
      return {
        ...state,
        removeDaysRequestStatus: {
          state: REQUEST_LOADING,
          requestId: payload.tripObjectId
        }
      };
    case REMOVE_DAYS_SUCCESS:
      return {
        ...state,
        removeDaysRequestStatus: {
          state: REQUEST_SUCCESS,
          requestId: payload.tripObjectId
        }
      };
    case REMOVE_DAYS_FAIL:
      return {
        ...state,
        removeDaysRequestStatus: {
          state: REQUEST_FAIL,
          requestId: payload.tripObjectId
        }
      };
    case ADD_TRIP:
      return {
        ...state,
        addTripRequestStatus: {
          state: REQUEST_LOADING
        }
      };
    case ADD_TRIP_LOADING:
      return {
        ...state,
        addTripRequestStatus: {
          ...state.addTripRequestStatus,
          state: REQUEST_LOADING
        }
      };
    case ADD_TRIP_SUCCESS:
      return {
        ...state,
        addTripRequestStatus: {
          state: REQUEST_SUCCESS,
          requestId: payload.results._id
        }
      };
    case ADD_TRIP_FAIL:
      return {
        ...state,
        addTripRequestStatus: {
          state: REQUEST_FAIL
        }
      };
    case COPY_TRIP:
      return {
        ...state,
        copyTripRequestStatus: {
          state: REQUEST_LOADING
        }
      };
    case COPY_TRIP_SUCCESS:
      return {
        ...state,
        copyTripRequestStatus: {
          state: REQUEST_SUCCESS,
          requestId: payload.results._id
        },
        /**
         * 由於行程頁會在 DidMount 時檢查是否 call 過後端資料以達到不重複呼叫 API 目的
         * 這會導致 複製遊記行程成功 後 進入行程頁卻沒顯示該筆行程(必須再次重新整理才出現）
         * 故複製遊記行程成功時也把行程頁 fetch 狀態改回預設值
         * 下次進入行程頁就會觸發 DidMount 時重新呼叫 API
         */
        fetchMyTripListRequestStatus: { state: REQUEST_NORMAL }
      };
    case COPY_TRIP_FAIL:
      return {
        ...state,
        copyTripRequestStatus: {
          state: REQUEST_FAIL
        }
      };
    case DELETE_TRIP:
      return {
        ...state,
        deleteTripRequestStatus: {
          state: REQUEST_LOADING,
          requestId: payload.tripObjectId
        }
      };
    case DELETE_TRIP_SUCCESS:
      return {
        ...state,
        deleteTripRequestStatus: {
          state: REQUEST_SUCCESS,
          requestId: payload.tripObjectId
        }
      };
    case DELETE_TRIP_FAIL:
      return {
        ...state,
        deleteTripRequestStatus: {
          state: REQUEST_FAIL,
          requestId: payload.tripObjectId
        }
      };
    case DELETE_SHARED_TRIP:
      return {
        ...state,
        deleteSharedTripRequestStatus: {
          state: REQUEST_LOADING,
          requestId: payload.tripObjectId
        }
      };
    case DELETE_SHARED_TRIP_SUCCESS:
      return {
        ...state,
        deleteSharedTripRequestStatus: {
          state: REQUEST_SUCCESS,
          requestId: payload.tripObjectId
        }
      };
    case DELETE_SHARED_TRIP_FAIL:
      return {
        ...state,
        deleteSharedTripRequestStatus: {
          state: REQUEST_FAIL,
          requestId: payload.tripObjectId
        }
      };
    case ACCEPT_SEND_ITINERARY:
      return {
        ...state,
        acceptSendItineraryRequestStatus: {
          state: REQUEST_LOADING,
          requestId: payload.objectId
        }
      };
    case ACCEPT_SEND_ITINERARY_SUCCESS:
      // show message toast if accept the itinerary
      if (payload.accept) {
        return {
          ...state,
          acceptSendItineraryRequestStatus: {
            state: REQUEST_SUCCESS,
            requestId: payload.objectId
          }
        };
      }
      return {
        ...state,
        acceptSendItineraryRequestStatus: {
          state: REQUEST_SUCCESS,
          requestId: payload.objectId
        }
      };
    case ACCEPT_SEND_ITINERARY_FAIL:
      return {
        ...state,
        acceptSendItineraryRequestStatus: {
          state: REQUEST_FAIL,
          requestId: payload.objectId
        }
      };
    case ACCEPT_SHARED_TRIP:
      return {
        ...state,
        acceptSharedTripRequestStatus: {
          state: REQUEST_LOADING,
          requestId: payload.objectId
        }
      };
    case ACCEPT_SHARED_TRIP_SUCCESS:
      // show message toast if accept to join travel group
      if (payload.accept) {
        return {
          ...state,
          acceptSharedTripRequestStatus: {
            state: REQUEST_SUCCESS,
            requestId: payload.objectId
          }
        };
      }
      return {
        ...state,
        acceptSharedTripRequestStatus: {
          state: REQUEST_SUCCESS,
          requestId: payload.objectId
        }
      };
    case ACCEPT_SHARED_TRIP_FAIL:
      return {
        ...state,
        acceptSharedTripRequestStatus: {
          state: REQUEST_FAIL,
          requestId: payload.objectId
        }
      };
    case CUSTOMIZE_TRANSPORTATION_TIME:
      return {
        ...state,
        customizeTransportationTimeRequestStatus: {
          state: REQUEST_LOADING,
          requestId: payload.poiObjectId
        }
      };
    case CUSTOMIZE_TRANSPORTATION_TIME_FAIL:
      return {
        ...state,
        customizeTransportationTimeRequestStatus: {
          state: REQUEST_FAIL,
          requestId: payload.poiObjectId
        }
      };
    case CUSTOMIZE_TRANSPORTATION_TIME_SUCCESS:
      return {
        ...state,
        customizeTransportationTimeRequestStatus: {
          state: REQUEST_SUCCESS,
          requestId: payload.poiObjectId
        }
      };
    case FETCH_MY_COLLECTIONS:
      return {
        ...state,
        fetchMyCollectionsRequestStatus: {
          state: REQUEST_LOADING,
          requestId: payload.memberObjectId
        }
      };
    case FETCH_MY_COLLECTIONS_FAIL:
      return {
        ...state,
        fetchMyCollectionsRequestStatus: {
          state: REQUEST_FAIL,
          requestId: payload.memberObjectId
        }
      };
    case FETCH_MY_COLLECTIONS_SUCCESS:
      return {
        ...state,
        fetchMyCollectionsRequestStatus: {
          state: REQUEST_SUCCESS,
          requestId: payload.memberObjectId
        }
      };
    case FETCH_COLLECTIONS_FOLDERS.LOADING:
      return {
        ...state,
        fetchMyCollectionsFoldersRequestStatus: {
          state: REQUEST_LOADING
        }
      };
    case FETCH_COLLECTIONS_FOLDERS.SUCCESS:
      return {
        ...state,
        fetchMyCollectionsFoldersRequestStatus: {
          state: REQUEST_SUCCESS
        }
      };
    case FETCH_COLLECTIONS_FOLDERS.FAIL:
      return {
        ...state,
        fetchMyCollectionsFoldersRequestStatus: {
          state: REQUEST_FAIL
        }
      };
    case FETCH_SHARED_COLLECTIONS_FOLDERS:
      return {
        ...state,
        fetchSharedCollectionsFoldersRequestStatus: {
          state: REQUEST_LOADING,
          requestId: payload.memberObjectId
        }
      };
    case FETCH_SHARED_COLLECTIONS_FOLDERS_FAIL:
      return {
        ...state,
        fetchSharedCollectionsFoldersRequestStatus: {
          state: REQUEST_FAIL,
          requestId: payload.memberObjectId
        }
      };
    case FETCH_SHARED_COLLECTIONS_FOLDERS_SUCCESS:
      return {
        ...state,
        fetchSharedCollectionsFoldersRequestStatus: {
          state: REQUEST_SUCCESS,
          requestId: payload.memberObjectId
        }
      };
    case FETCH_MY_COLLECTIONS_IN_FOLDER:
      return {
        ...state,
        fetchMyCollectionsInFolderRequestStatus: {
          state: REQUEST_LOADING,
          requestId: payload.folderObjectId
        }
      };
    case FETCH_MY_COLLECTIONS_IN_FOLDER_FAIL:
      return {
        ...state,
        fetchMyCollectionsInFolderRequestStatus: {
          state: REQUEST_FAIL,
          requestId: payload.folderObjectId
        }
      };
    case FETCH_MY_COLLECTIONS_IN_FOLDER_SUCCESS:
      return {
        ...state,
        fetchMyCollectionsInFolderRequestStatus: {
          state: REQUEST_SUCCESS,
          requestId: payload.folderObjectId
        }
      };
    case ADD_POI_TO_COLLECTIONS:
      return {
        ...state,
        addPoiToCollectionsRequestStatus: {
          state: REQUEST_LOADING,
          requestId: payload.memberObjectId
        }
      };
    case ADD_POI_TO_COLLECTIONS_FAIL:
      return {
        ...state,
        addPoiToCollectionsRequestStatus: {
          state: REQUEST_FAIL,
          requestId: payload.memberObjectId
        }
      };
    case ADD_POI_TO_COLLECTIONS_SUCCESS:
      return {
        ...state,
        addPoiToCollectionsRequestStatus: {
          state: REQUEST_SUCCESS,
          requestId: payload.memberObjectId
        }
      };
    case ADD_POI:
      return {
        ...state,
        addPoiToTripRequestStatus: {
          state: REQUEST_LOADING,
          requestId: payload.tripObjectId
        }
      };
    case ADD_POI_FAIL:
      return {
        ...state,
        addPoiToTripRequestStatus: {
          state: REQUEST_FAIL,
          requestId: payload.tripObjectId
        }
      };
    case ADD_POI_SUCCESS:
      return {
        ...state,
        addPoiToTripRequestStatus: {
          state: REQUEST_SUCCESS,
          requestId: payload.tripObjectId
        }
      };
    case ERASE_TRIP_LIST:
      return {
        ...state,
        fetchMyTripListRequestStatus: { state: REQUEST_NORMAL },
        copyTripRequestStatus: { state: REQUEST_NORMAL }
      };
    case GEO_CODE_FAIL:
      return {
        ...state,
        geocodeRequestStatus: {
          state: REQUEST_FAIL,
          requestId: payload.address
        }
      };
    case GEO_CODE_SUCCESS:
      return {
        ...state,
        geocodeRequestStatus: {
          state: REQUEST_SUCCESS,
          requestId: payload.address,
          poi: payload.poi
        }
      };
    case GEO_CODE:
      return {
        ...state,
        geocodeRequestStatus: {
          state: REQUEST_LOADING,
          requestId: payload.address
        }
      };
    case USER_LOG_OUT:
      /**
       * 登出後須將 fetchPoisRequestStatus 清理成 init 值
       * 若當下使用者是在行程頁登出 登出後應馬上發一次"未登入訪客權限"的 POI AJAX
       * 不清成 init 值時會因 Redux fetchPoisRequestStatus 還留有登入前狀態而不發出 "已登入權限" 的 POI AJAX
       * */
      return {
        ...state,
        fetchMyTripListRequestStatus: { state: REQUEST_NORMAL },
        fetchPoisRequestStatus: {
          state: REQUEST_NORMAL,
          requestId: null,
          statusCode: null
        }
      };
    case USER_LOGIN:
      /**
       * 考量使用者可能在行程頁登出 登出後清除 fetchPoisRequestStatus 成預設值
       * 且因使用者當下在行程頁正常要馬上發一次"未登入訪客權限"的 POI AJAX 並寫入 fetchPoisRequestStatus
       * 若這時再次登入(不管登入成功失敗或是否相同帳號）都須將 fetchPoisRequestStatus 也清理成 init 值
       * 否則 fetchPoisRequestStatus 留存 "未登入訪客權限" 狀態導致行程頁會不發 "已登入權限" 的 POI AJAX
       *  */
      return {
        ...state,
        userLoginRequestStatus: { state: REQUEST_LOADING },
        fetchPoisRequestStatus: {
          state: REQUEST_NORMAL,
          requestId: null,
          statusCode: null
        }
      };
    case USER_LOGIN_SUCCESS:
      return {
        ...state,
        userLoginRequestStatus: { state: REQUEST_SUCCESS }
      };
    case USER_LOGIN_FAIL:
      return {
        ...state,
        userLoginRequestStatus: { state: REQUEST_FAIL }
      };
    // poi bank
    case FETCH_POI_DETAIL_FROM_POI_BANK: // loading poi detail data
      return {
        ...state,
        fetchPoiDetailFromPoiBankRequestStatus: {
          state: REQUEST_LOADING,
          requestId: payload.poiObjectId
        }
      };
    case FETCH_POI_DETAIL_FROM_POI_BANK_SUCCESS: // poi detail request success
      return {
        ...state,
        fetchPoiDetailFromPoiBankRequestStatus: {
          state: REQUEST_SUCCESS,
          requestId: payload.poiObjectId
        }
      };
    case FETCH_POI_DETAIL_FROM_POI_BANK_FAIL: // poi detail request fail
      return {
        ...state,
        fetchPoiDetailFromPoiBankRequestStatus: {
          state: REQUEST_FAIL,
          requestId: payload.poiObjectId
        }
      };
    case FETCH_CITY_AUTOCOMPLETE:
      return {
        ...state,
        cityAutoCompleteRequestStatus: {
          state: REQUEST_LOADING,
          requestId: payload.keyword
        }
      };
    case FETCH_CITY_AUTOCOMPLETE_SUCCESS:
      return {
        ...state,
        cityAutoCompleteRequestStatus: {
          state: REQUEST_SUCCESS,
          requestId: payload.keyword
        }
      };
    case FETCH_CITY_AUTOCOMPLETE_FAIL:
      return {
        ...state,
        cityAutoCompleteRequestStatus: {
          state: REQUEST_FAIL,
          requestId: payload.keyword
        }
      };
    case CLEAR_CITY_AUTOCOMPLETE:
      return {
        ...state,
        cityAutoCompleteRequestStatus: {
          state: REQUEST_NORMAL,
          requestId: null
        }
      };

    // case FETCH_RECOMMENDED_POI_SUCCESS:
    //   return {
    //     ...state,
    //     fetchRecommendedPoiRequestStatus: {
    //       state: REQUEST_SUCCESS,
    //       requestId: null,
    //     },
    //   };
    case FETCH_RECOMMENDED_POI_FAIL:
      return {
        ...state,
        fetchRecommendedPoiRequestStatus: {
          state: REQUEST_FAIL,
          requestId: null
        }
      };
    // case SEARCH_POI_SUCCESS:
    //   return {
    //     ...state,
    //     searchPoiRequestStatus: {
    //       state: REQUEST_SUCCESS,
    //       requestId: payload.keyword,
    //     },
    //   };
    case SEARCH_POI_FAIL:
      return {
        ...state,
        searchPoiRequestStatus: {
          state: REQUEST_FAIL,
          requestId: payload.keyword
        }
      };
    case SEARCH_POI:
      return {
        ...state,
        searchPoiRequestStatus: {
          state: REQUEST_LOADING,
          requestId: payload.keyword
        }
      };
    case CLEAR_POI_LIST:
      return {
        ...state,
        searchPoiRequestStatus: { state: REQUEST_NORMAL, requestId: null },
        fetchRecommendedPoiRequestStatus: {
          state: REQUEST_NORMAL,
          requestId: null
        },
        cityGeocodeRequestStatus: { state: REQUEST_NORMAL, requestId: null }
      };
    case POI_BANK_CITY_GEOCODE_SUCCESS:
      return {
        ...state,
        cityGeocodeRequestStatus: { state: REQUEST_SUCCESS, requestId: null }
      };
    case POI_BANK_CITY_GEOCODE_FAIL:
      return {
        ...state,
        cityGeocodeRequestStatus: { state: REQUEST_FAIL, requestId: null }
      };
    case POI_BANK_CITY_GEOCODE:
      return {
        ...state,
        cityGeocodeRequestStatus: { state: REQUEST_LOADING, requestId: null }
      };

    case FETCH_JOURNAL_LIKE_SUCCESS:
      return {
        ...state,
        fetchJournalLikeRequestStatus: {
          state: REQUEST_SUCCESS,
          requestId: null
        }
      };
    case FETCH_JOURNAL_LIKE_FAIL:
      return {
        ...state,
        fetchJournalLikeRequestStatus: {
          state: REQUEST_FAIL,
          requestId: null
        }
      };
    case FETCH_JOURNAL_LIKE_LOADING:
      return {
        ...state,
        fetchJournalLikeRequestStatus: {
          state: REQUEST_LOADING,
          requestId: null
        }
      };
    case COPY_TRIP_FROM_ITINERARY.INIT:
      return {
        ...state,
        fetchSocialCopyRequestStatus: {
          state: REQUEST_INIT
        }
      };
    case COPY_TRIP_FROM_ITINERARY.LOADING:
      return {
        ...state,
        fetchSocialCopyRequestStatus: {
          state: REQUEST_LOADING
        }
      };
    case COPY_TRIP_FROM_ITINERARY.SUCCESS:
      return {
        ...state,
        fetchSocialCopyRequestStatus: {
          state: REQUEST_SUCCESS
        }
      };
    case COPY_TRIP_FROM_ITINERARY.FAIL:
      return {
        ...state,
        fetchSocialCopyRequestStatus: {
          state: REQUEST_FAIL
        }
      };
    case RESET_ITINERARY: {
      const { initRequestStatus, poiBankInitRequestStatus } = state;
      const newState = {
        ...originState,
        initRequestStatus,
        poiBankInitRequestStatus
      };

      return {
        ...state,
        ...newState
      };
    }
    default:
      return state;
  }
};
